import ProjectSettings from './pages/dashboard/project-settings.svelte';
import Modal from './frame-components/modal.svelte';
import App from './app.svelte';

const web_svelte = {
	ProjectSettings,
	Modal,
	App
}

export default web_svelte;
